import { defineMessages } from "react-intl";

const PREFIX = "Subscriptions.SavedSubscriptionDialog";
export default defineMessages({
  title: {
    id: `${PREFIX}.title`,
    defaultMessage: "Subscriptions",
  },
  message: {
    id: `${PREFIX}.contentText`,
    defaultMessage: "The subscription successfully saved",
  },
  confirm: {
    id: `${PREFIX}.confirm`,
    defaultMessage: "OK",
  },
});
